<template>
    <div>
        <div class="card border-primary mb-3">
            <h5 class="card-header text-primary"><i class="far fa-comment mr-2"></i>{{eventName}}</h5>
            <div class="card-body">
                <div class="alert alert-info" role="alert">
                    <h6>{{ $t('upcomingEvents.wrongEmailInfo')}}</h6>
                </div>
                <div class="form-group col-12">
                    <label class="font-weight-bold required" :for="'email' + _uid">
                        {{$t('upcomingEvents.email')}}
                    </label>
                    <kendo-dropdownlist
                        v-if="userEmails"
                        v-model="model.email"
                        :data-source="userEmails"
                        clear-button
                        v-validate="'required'"
                        :data-vv-as="$t('upcomingEvents.email')"
                        :name="'email' + _uid"
                        :id="'email' + _uid"
                        style="width: 100%;"
                    ></kendo-dropdownlist>
                    <span class="text-danger col-12" v-if="errors.has('email' + _uid)">{{ errors.first('email' + _uid) }}</span>
                </div>

                <div class="form-group col-12">
                    <label class="font-weight-bold" :for="'note' + _uid">
                        {{$t('upcomingEvents.note')}}
                    </label>
                    <input type="text"
                           class="form-control"
                           v-model="model.note"
                           :name="'note' + _uid"
                           :id="'note' + _uid" />
                </div>

                <div class="text-right mt-3">
                    <div class="btn-group" role="group" aria-label="Notification subscription edit buttons">
                        <button type="button" class="btn btn-success" @click.stop="onSave"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                    </div>
                </div>
            </div>

            <div class="card-footer text-muted">

            </div>
        </div>
    </div>
</template>

<script>
    import { NotificationSubscription } from '@/models/models';
    import eventService from '@/services/event.service';
    import userService from '@/services/user.service';
    import { mapGetters } from 'vuex';
    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: NotificationSubscription,
                required: true
            },
            create: {
                type: Boolean,
                default: false
            },
            eventName: String
        },
        data() {
            return {
                model: this.value,
                userEmails: null
            }
        },
        computed: {
            ...mapGetters(['isEnVersion'])
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new NotificationSubscription(val);
                }
            }
        },
        mounted() {
            this.getUserEmails();
        },
        methods: {
            onCancel() {
                this.$emit("cancel");
            },
            onSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        kendo.confirm(this.$t('upcomingEvents.confirmations.notificationSubsciption'))
                            .then(function () {
                               this.doSave();
                            }.bind(this));
                    }
                });
            },
            doSave() {
                 eventService.subscribeForEventNotification(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    })
            },
            getUserEmails() {
                userService.getLoggedUserEmails()
                    .then(response => {
                        this.userEmails = response.data;
                    })
                    .catch(error => {
                        console.log(error.response);
                    })
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
